<script>
  export let title
  export let src
</script>

<style>
</style>

<iframe
  {title}
  {src}
  allow="fullscreen"
  allowfullscreen />
